import { deleteComment } from '../../actions/delete-comment';
import { demoteWriter } from '../../actions/demote-writer';
import { openSettingsDialog } from '../../actions/open-settings-dialog';
import { promoteWriter } from '../../actions/promote-writer';
import { reportComment } from '../../actions/report-comment';
import { reportPost } from '../../actions/report-post';
import { reportUser } from '../../actions/report-user';
import messages, * as messageTypes from '../../components/message/messages';
import * as modalTypes from '@wix/communities-blog-client-common/dist/src/constants/modal-types';
import { handlePostDelete } from '../../services/handle-post-delete';

export default {
  [modalTypes.MODAL_TYPE_DELETE_POST]: handlePostDelete({ permanently: false }),

  [modalTypes.MODAL_TYPE_DELETE_COMMENT]: (payload, { showMessage }) => dispatch => {
    return dispatch(deleteComment({ postId: payload.postId, commentId: payload.commentId })).then(() =>
      showMessage(messages[messageTypes.COMMENT_DELETE].content(), messages[messageTypes.COMMENT_DELETE].type),
    );
  },

  [modalTypes.MODAL_TYPE_PROMOTE_WRITER]: (userId, { showMessage }) => dispatch => {
    return dispatch(promoteWriter(userId)).then(() =>
      showMessage(
        messages[messageTypes.MEMBER_PROMOTE_WRITER].content(),
        messages[messageTypes.MEMBER_PROMOTE_WRITER].type,
      ),
    );
  },

  [modalTypes.MODAL_TYPE_DEMOTE_WRITER]: (userId, { showMessage }) => dispatch => {
    return dispatch(demoteWriter(userId)).then(() =>
      showMessage(
        messages[messageTypes.MEMBER_DEMOTE_WRITER].content(),
        messages[messageTypes.MEMBER_DEMOTE_WRITER].type,
      ),
    );
  },

  [modalTypes.MODAL_TYPE_REPORT_COMMENT]: report => reportComment(report),

  [modalTypes.MODAL_TYPE_REPORT_POST]: report => reportPost(report),

  [modalTypes.MODAL_TYPE_REPORT_MEMBER]: report => reportUser(report),

  [modalTypes.MODAL_TYPE_DEMO_MODE]: data => dispatch => {
    if (data) {
      dispatch(openSettingsDialog());
    }
  },
};
